import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=a236c3e6&scoped=true"
import script from "./TermsModal.vue?vue&type=script&lang=ts"
export * from "./TermsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a236c3e6",
  null
  
)

export default component.exports